import TextComponent from './text'
import PasswordComponent from './password'
import FormGroupComponent from './formGroup'
import CheckboxComponent from './checkbox'
import RadioComponent from './radio'
import SelectComponent from './select'
import TextareaComponent from './textarea'
import FormComponent from './form'
import SerializeComponent from './serialize'

export const Text = TextComponent
export const Password = PasswordComponent
export const FormGroup = FormGroupComponent
export const Checkbox = CheckboxComponent
export const Radio = RadioComponent
export const Select = SelectComponent
export const form = FormComponent
export const serialize = SerializeComponent
export const Textarea = TextareaComponent


// WEBPACK FOOTER //
// ./src/components/atoms/Forms/index.js